import { createApiClient } from "./apiClient";

export class ArtService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/arts");
  }

  async getArt(id) {
    return this.apiClient.get(id);
  }

  async updateArt(id, params) {
    return this.apiClient.patch(id, params, { timeout: 20000 });
  }

  async createArt(params) {
    const res = await this.apiClient.post("", params, { timeout: 20000 });
    return res.id;
  }

  async getMembers(id) {
    return this.apiClient.get(`${id}/members`);
  }

  async getArts(order) {
    const res = await this.apiClient.get("", { params: { order } });
    return res?.results;
  }

  async deleteArt(id) {
    return this.apiClient.delete(id);
  }
}
